export const WIDGET_OPTIONS_BUTTON_ID = 'widget-options-button';
export const WIDGET_ADD_BUTTON_ID = 'widget-add-button';
export const WIDGET_EDIT_BUTTON_ID = 'widget-edit-button';
export const HEADER_EDIT_BUTTON_ID = 'header-edit-button';
export const DASHBOARD_NAME_EDIT_BUTTON_ID = 'dashboard-name-edit-button-id';
export const DRAGGABLE_CLASS_NAME = 'DragHandleClass';

export const ROW_HEIGHT = 36;
export const DASHBOARD_COL_NUMBER = 3;
export const DASHBOARD_GAP = 16;
export const DASHBOARD_MAX_WIDTH = 1720;
export const DASHBOARD_MIN_SCREEN_WIDTH = 1280;
export const DASHBOARD_MIN_SCREEN_WIDTH_SMALL = 820;
export const DASHBOARD_MAX_SCREEN_WIDTH = 1920;
export const DASHBOARD_MIN_WIDTH = 1160;
export const HEADER_BAR_HEIGHT = 48;
export const WIDGET_MIN_ROWS = 5;
export const WIDGET_ASPECT_WIDTH = 375;
/* Where the pie chart legend stops responding to width — see
   getResizeOptionsCallback in PieChartWidget. */
const WIDGET_COLUMN_MIN_WIDTH = 335;
export const WIDGETS_GRID_MIN_WIDTH =
  DASHBOARD_COL_NUMBER * WIDGET_COLUMN_MIN_WIDTH +
  (DASHBOARD_COL_NUMBER - 1) * DASHBOARD_GAP;
export const WIDGET_ASPECT_HEIGHT = 239;
export const PAGE_BODY_PADDING = 32;
export const DASHBOARD_NAME_ISLAND_ID = 'dashboard-name-island';

export const DEFAULT_WIDGET_COL_SPAN = 1;
export const HEADER_WIDGET_COL_SPAN = 3;
export const BUBBLE_CHART_WIDGET_COL_SPAN = 3;
export const OTHER_SEGMENT_NAME = 'Others';
export const OTHER_SEGMENT_FROM_BACKEND_NAME = ':ardoq/other';

export const DEFAULT_BAR_CHART_SECONDARY_COLOR = '#C5C2C3';
export const DEFAULT_BAR_CHART_PRIMARY_COLOR = '#2974C4FF';
export const DEFAULT_NUMBER_OF_SEGMENTS_FOR_PIE_CHARTS_AND_STACKED_BAR_CHARTS = 5;
export const MAXIMUM_NUMBER_OF_SEGMENTS_FOR_PIE_CHARTS_AND_STACKED_BAR_CHARTS = 20;
export const DEFAULT_NUMBER_OF_SEGMENTS_FOR_BAR_CHARTS = 16;
export const MAXIMUM_NUMBER_OF_SEGMENTS_FOR_BAR_CHARTS = 30;

// The current report filters don't distinguish between not set and N/A values,
// drilldown api is returning both togther when filter by null value.
// Dashboard api has the same behavior.
// This label is used at both cases to represent null value correctly.
export const UNSET_OR_NOTAPPLICABLE_VALUE_LABEL = 'Not set or N/A';
